import { LanguageContextType, useLanguage } from "~/context/LanguageContext";

/** Picks the current locale's slice out of a namespace dictionary. */
export function useT<T>(dict: Record<LanguageContextType["lang"], T>): T {
  const { lang } = useLanguage();
  return dict[lang];
}
